module.exports = __webpack_public_path__ + "2-49.jpg?bf502ddab7ad8c03ec040f0835a358fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-49.jpg
// module id = 126
// module chunks = 0